<table class="table table-sm placeholder-glow" data-cy="userPharmacies">
  <tbody>
    @if (items === undefined) {
      @for (_ of [].constructor(field.props?.placeholdersAmount ?? 2); track $index) {
        <tr>
          <td></td>
          <td><span class="placeholder col-6">Loading...</span></td>
          <td></td>
        </tr>
      }
    }
    @if (items && items.length === 0) {
      <tr>
        <td class="text-center">No items found</td>
      </tr>
    }
    @for (item of items; track item; let i = $index) {
      <tr
        class="row-rise"
        [style.--cl-row-i]="i"
        [ngClass]="{ 'table-danger': item.selectedAction === 'REMOVE', 'table-success': item.selectedAction === 'ADD' }"
      >
        <td class="text-center action-symbol">
          <i class="fa-solid" [ngClass]="{ 'fa-minus': item.selectedAction === 'REMOVE', 'fa-plus': item.selectedAction === 'ADD' }"></i>
        </td>
        <td [ngClass]="{ 'text-decoration-line-through': item.selectedAction === 'REMOVE' }">{{ item.label ?? item.value }}</td>
        <td class="text-center">
          <a (click)="onActionClicked(i)">
            <i
              class="fa-solid"
              [ngClass]="{
                'fa-rotate-left': item.selectedAction === 'REMOVE',
                'fa-circle-xmark': item.selectedAction === 'ADD',
                'fa-trash': item.selectedAction === undefined,
              }"
              data-cy="binBtn"
            ></i>
          </a>
        </td>
      </tr>
    }
  </tbody>
</table>

<div class="row">
  <div class="col-6 ms-auto">
    <div class="mb-2">
      <div class="input-group" data-cy="addPharmacyInput">
        <input
          type="text"
          class="form-control"
          [placeholder]="this.field.props?.placeholder"
          [(ngModel)]="newItemValue"
          (ngModelChange)="onNewItemValueChanged()"
        />
        <button class="btn btn-primary" data-cy="addBtn" type="button" (click)="onAddItemClicked()">
          @if (!isAdding) {
            <span>Add</span>
          }
          @if (isAdding) {
            <div class="spinner-border spinner-border-sm text-white mx-4">
              <span class="sr-only">Adding...</span>
            </div>
          }
        </button>
        @if (itemAddError) {
          <span class="text-danger ms-auto w-100">{{ itemAddError }}</span>
        }
      </div>
    </div>
  </div>
</div>
